import {
  Dialog,
  DialogContent,
  DialogTitle,
  Alert
} from "@mui/material";
import { FC, useEffect } from "react";
// import {actions as bvActions} from "../../slices/virtualBattery";
import useMoveVirtualBatteryContext from "./useMoveVirtualBatteryContext";
import HorizontalLinearStepper from "./MoveVirtualBatteryStepper/MoveVirtualBatteryStepper";
import { useContracts } from "@/components/Contracts/hooks/useContracts";
import { useTranslation } from "react-i18next";
import { useVirtualBatteries } from "../../hooks/useVirtualBatteries";
import { IBateriaVirtual } from "../../types/virtualBattery";

interface MoveVirtualBatteryDialogParams {
  open: boolean;
  bateriaVirtual: IBateriaVirtual; 
  onClose: () => void;
}

/*
 * Feature component
 *
 * Responsible for rendering a dialog that contain all the components to make a virtual batery movment
 * - Delegate the rendering of distribution preview to `BateriaVirtualMoveRepartimentPreviewer` component.
 * - Delegate the rendering of new destination batery selector to `BateriaVirtualMoveSelector` component.
 * - Will fetch and posts the changes made
 */
const MoveVirtualBatteryDialog: FC<MoveVirtualBatteryDialogParams> = ({
  open, 
  bateriaVirtual, 
  onClose 
}) => {
  const { t } = useTranslation();
  const {
    selectedBatteryId,
    newPercentage,
    setNewPercentage,
    setBateriaVirtualToMove,
    reset
  } = useMoveVirtualBatteryContext();

  const {
    currentContract,
    fetchContracts
  } = useContracts("electricity");

  const {
    error,
    isWaitingChangeRequest,
    bateriaVirtualPercentages,
    fetchPercentages,
    moveVirtualBatteries
  } = useVirtualBatteries();

  const serverBateriaVirtual = bateriaVirtualPercentages?.find(
    (e) => e.bateria_id === bateriaVirtual.id
  );

  useEffect(() => {
    setBateriaVirtualToMove(bateriaVirtual);
    setNewPercentage(bateriaVirtual.pes_percentatge); // INFO: By default the full weight defined
    fetchPercentages(bateriaVirtual.bateria.id);
  }, [bateriaVirtual]);

  const handleSubmit = () => {
    moveVirtualBatteries(
      currentContract.name,
      bateriaVirtual.bateria.id,
      selectedBatteryId!,
      newPercentage!
    ).then(res => {
      reset();
    }).catch(err => {
      serverBateriaVirtual && setNewPercentage(serverBateriaVirtual.percentage);
    }).finally(() => {
      onClose();
    });
    
    // fetchPercentages(bateriaVirtual.bateria.id);
    // Possible bug si estàs modificant un contracte que és fora de la paginació
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("common:text.virtual_battery_move")}</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error">
            {t("common:text.message_cant_do_operation")}
          </Alert>
        )}
        {t("common:text.virtual_battery_move_notice")}
        <HorizontalLinearStepper
          onClose={onClose}
          onSubmit={handleSubmit}
          disabled={isWaitingChangeRequest || !selectedBatteryId }
        />
      </DialogContent>
    </Dialog>
  );
};

export default MoveVirtualBatteryDialog;
